






















































import BaseComponent from "@/core/components/BaseComponent";
import {Prop, Watch} from "vue-property-decorator";
import {HasAddress} from "@/interfaces/HasAddress";
import Component from "vue-class-component";
import _ from "lodash";
import axios from "axios";

@Component({
    components: {}
})
export default class AddressEdit extends BaseComponent {

    // Bindings to parent
    @Prop() model?: HasAddress;

    // Bindings to view
    public address?: string;
    public search: string = "";
    public loading = false;
    public items: any[] = [];

    public street?: string;
    public zip?: string;
    public city?: string;

    // Data
    private debouncedSearch?: any;

    public created() {
        this.debouncedSearch = _.debounce(this.searchDawa, 300);
    }

    public mounted() {
        this.renderView();
    }

    private renderView() {
        this.address = `${this.model?.street} ${this.model?.zip} ${this.model?.city}`;
        this.street = this.model?.street ?? '';
        this.zip = this.model?.zip ?? '';
        this.city = this.model?.city ?? '';
        this.isReady = true;
    }

    @Watch("search")
    private onSearchChange() {
        this.debouncedSearch();
    }

    private searchDawa() {
        const selectedItem = this.items?.find(item => item.forslagstekst == this.search);
        if (selectedItem) {
            this.selectItem(selectedItem);
        }

        axios.get('https://api.dataforsyningen.dk/autocomplete', {
            params: {
                q: this.search,
            }
        }).then(response => {
            this.items = response?.data ?? [];
        }).catch(error => {

        });
    }

    private selectItem(payload: any) {
        this.street = payload.data?.adresseringsvejnavn ?? '';
        if (payload.data?.husnr) {
            this.street += ` ${payload.data?.husnr}`;
        }
        if (payload.data?.etage) {
            this.street += ` ${payload.data?.etage}`;
        }
        if (payload.data?.dør) {
            this.street += ` ${payload.data?.dør}`;
        }
        this.zip = payload.data?.postnr ?? '';
        this.city = payload.data?.postnrnavn ?? '';
        if (this.street!.length > 0 && this.zip!.length > 0 && this.city!.length > 0) {
            this.model!.street = this.street;
            this.model!.zip = this.zip;
            this.model!.city = this.city;
            this.$emit('save', this.model);
        }
    }

}
